import { IDropdownOption } from "@fluentui/react";
import { IQuoteErrors } from "./Common/Interfaces/IQuoteErrors";
import { ICustomerInfo } from "./Common/Interfaces/ICustomerInfo";
import { ISearchSkuResponse } from "../../common/Interfaces/ISearchSkuResponse";
import { IExtendedDetailItemEntity, IExtendedItemEntity } from "./Common/Interfaces/IItemEntity";

export enum LineItemType {
  NonModifed = 0,
  Add = 1,
  Edit = 2,
  Remove = 3,
}

export interface IQuotationPayload {
  status: string;
  msContact: string;
  records: number;
  skip: number;
  searchText: string;
}

export interface IQuotationResponse {
  id: string;
  partitionKey: string;
  quotationNum: string | null;
  quotationName: string;
  quotationType: string;
  customerAccount: string;
  customerName: string;
  msxOpportunityId: string;
  quotationStatus: string;
  channel: string | null;
  salesOrigin: string | null;
  status: string;
  url: string;
  customerId: string;
  total: string;
  createdAt: string;
  expireAt: string;
  paymentType: string;
  poNumber: string;
}

export interface IExtendedQuotationResponse {
  key: number;
  item: IQuotationResponse;
}

export interface IAuthDiscountAmounts {
  expirationDate: string;
  authorizedDiscountReason: string;
  authorizedDiscountAmount: number;
  authorizedDiscountPercentage: number;
  minimumAuthorizedDiscountAmount: number;
};
export interface IItemDetailEntity {
  lineItemId: string;
  skuId: string;
  productName: string;
  quantity: number;
  availableInventory: number;
  reservedInventory: number;
  unitPrice: number;
  msrp: number;
  discount: number;
  discountPercent: number;
  authorizedDiscount: number;
  netAmount: number;
  lineTotal: number;
  lineTotalWithTax: number;
  lineItemTax: number;
  effectiveTaxRate: number;
  levyFeeAmount: number;
  totalLineLevyFeeAmount: number;
  lineItemType: LineItemType;
  discountReason: string;
  authDiscountAmounts: IAuthDiscountAmounts[];
  lineItemIndex: number;
  taxType: string;
}
// // [];
export interface ILineItemDetailEntity extends IItemDetailEntity {
  deviceType: string;
}
export interface IBundleItemEntity {
  index: number;
  sapItemId: string;
  // key: string;
  // name: string;
  bundleId: string;
  bundleTitle: string;
  startIndex: number;
  count: number;
  quantity: number;
}
export interface IBundleLineItemDetailEntity {
  index: number;
  key: string;
  name: string;
  deviceType: string;
  data: IItemDetailEntity[];
  // children: item,
  startIndex: number;
  count: number,
  level: number;
}

export interface ProductiveTimeTracking {
  FillQuoteSessionEndtimeInSeconds?: number;
  // Add other fields as needed
}

export type QuotationInfo = {
  quotationId: string;
  partitionKey: string;
  quotationNumber: string;
  quotationName: string;
  quotationDescription: string;
  quotationDate: string;
  expiryDate: string;
  customerRequestedPromiseDate: string;
  total: string;
  subTotal: string;
  totalTax: string;
  totalFee: string;
  customer: ICustomerInfo;
  // companyDetail: ICompanyDetail;
  // authorizedBuyers: IAuthorizedBuyers;
  // billingProfile: IBillingProfile;
  // shipTo: IShipTo;
  // billTo: IBillTo;
  status: string;
  msxOpportunityId: string;
  paymentType: string;
  selectedPaymentType: IDropdownOption;
  paymentMethod: string;
  selectedPaymentMethod: IDropdownOption;
  paymentTerms: string;
  selectedPaymentTerms: IDropdownOption;
  adyenPaymentLink: string;
  customerPurchaseOrder: string;
  deliveryMode: string;
  selectedDeliveryMode: IDropdownOption;
  deliveryReason: string;
  selectedDeliveryReason: IDropdownOption;
  quoteCurrency: string;
  comments: string;
  microsoftAccountLead: string;
  microsoftAccountPhone: string;
  microsoftAccountEmail: string;
  preparedBy: string;
  createdBy: string;
  createdByName: string;
  modifiedById: string;
  modifiedByName: string;
  country: string;
  quoteLineItems: IItemDetailEntity[];
  quoteLineItemsClone: IItemDetailEntity[];
  standaloneItems: IExtendedItemEntity[] | IExtendedDetailItemEntity[];
  standaloneItemsClone: IExtendedItemEntity[] | IExtendedDetailItemEntity[];
  bundles: IBundleItemEntity[];
  bundleItems: IExtendedItemEntity[] | IExtendedDetailItemEntity[];
  bundleItemsClone: IExtendedItemEntity[] | IExtendedDetailItemEntity[];
  skuData: ISearchSkuResponse;
  searchedSku: string;
  taxExpirationDate: string;
  ProductiveTimeTracking?: ProductiveTimeTracking;
};

export type QuotationInfoType = {
  quotationInfo: QuotationInfo;
  setQuotationInfo: (quotationInfo: QuotationInfo) => void;
};

export type IQuotationType = {
  quotationInfo: QuotationInfo;
  setQuotationInfo: (quotationInfo: QuotationInfo) => void;
  quotationError: IQuoteErrors;
  setQuotationError: (quotationError: IQuoteErrors) => void;
};

export interface IResponseMessage {
  message: string;
  showMessage: boolean;
}
